import React from 'react';
import './SeletorData.css';

export default function SeletorDeDatas({ botoesData, aoSelecionarData, dataSelecionada, contagensBotoes }) {
  if (!botoesData || Object.keys(botoesData).length === 0) return null
  return (
    <div style={{ display: 'inline-flex', flexDirection: 'row' }}>
      {Object.entries(botoesData).map(([chave, data]) => {
        const estaAtivo = dataSelecionada === data;
        const quantidade = (contagensBotoes && contagensBotoes[chave]) || 0
        return (
          <button
            key={chave}
            onClick={() => aoSelecionarData(data, 'seletor')}
            className={`botao ${estaAtivo ? 'ativo' : ''}`}
          >
            {data} [{quantidade}]
          </button>
        );
      })}
    </div>
  );
}